import { Model } from "@/stores/AbstractBase.store";
import { EvaluationLevel } from "./EvaluationLevel.model";
import { User } from "./User.model";

export class Evaluation implements Model {

	public id?: string;
	public comment: string = '';
	public date?: Date;
	public evaluationLevel?: EvaluationLevel;
	public pupilId?: string;
	public goalId?: string;
	public author?: User;
	public goalCollectionId?: string;

	static createFromApiData(data: any): Evaluation {
		const evaluation = new Evaluation();
		evaluation.hydrateWithApiData(data);

		return evaluation;
	}

	hydrateWithApiData(data: any): void {
		
		this.id = data.id;
		this.comment = data.comment;
		this.date = data.date ? new Date(data.date) : undefined;

		this.evaluationLevel = EvaluationLevel.createFromApiData(data.evaluationLevel);

		if (data.author) {
			this.author = User.createFromApiData(data.author);
		}

		if (data.goal) {
			this.goalId = data.goal.id;
		}

		if (data.pupil) {
			this.pupilId = data.pupil.id;
		}

	}
	
	asApiDataObject() {
		
		const serverData: any = {
			comment: this.comment !== '' ? this.comment : null,
			date: this.date,
			evaluationLevel: {
				id: this.evaluationLevel?.id,
			},
			pupil: {
				id: this.pupilId,
			},
			goal: {
				id: this.goalId,
				goalCollection: this.goalCollectionId ? { id: this.goalCollectionId } : undefined,
			},
		}

		return serverData;
	}

	clone(): Model {
		throw new Error("Method not implemented.");
	}

	equals(other: Model): boolean {
		if (!(other instanceof Evaluation)) {
			return false;
		}

		return JSON.stringify(this.asApiDataObject()) === JSON.stringify(other.asApiDataObject());
	}
	
}
